exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".arrowIndicatorOverride__upArrow___3h_bf{border-bottom:12px solid #39b54a}.arrowIndicatorOverride__downArrow___3JCMo,.arrowIndicatorOverride__upArrow___3h_bf{width:0;height:0;border-right:6px solid transparent;border-left:6px solid transparent;float:right;margin-left:5px;margin-right:0;margin-top:0}.arrowIndicatorOverride__downArrow___3JCMo{border-top:12px solid #e30613}", ""]);

// exports
exports.locals = {
	"upArrow": "arrowIndicatorOverride__upArrow___3h_bf",
	"downArrow": "arrowIndicatorOverride__downArrow___3JCMo"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./src/client/components/ExplorerPDF/overrides/arrowIndicatorOverride.pcss
// module id = 881
// module chunks = 0